import AGREGAR_CONTRATO_RELACIONADO from '@/graphql/mutations/administracion/contratos/contrato/contratosRelacionados/agregarContratoRelacionado.gql';
import REMOVER_CONTRATO_RELACIONADO from '@/graphql/mutations/administracion/contratos/contrato/contratosRelacionados/removerContratoRelacionado.gql';
import CONTRATO_RELACIONADOS from '@/graphql/querys/administracion/contratos/contratosRelacionados/contratoRelacionados.gql';

export default {
  methods: {
    // Agregar Contrato Relacionado
    async mixAgregarcontratoRelacionado() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_RELACIONADO,
          variables: {
            idContrato: this.contratoRelacionado.idContrato,
            idContratoRelacionado: this.contratoRelacionado.idContratoRelacionado,
            esSupervisionExterna: this.contratoRelacionado.esSupervisionExterna,
          },
          // Agregar Contrato Relacionado a la Store
          update: (store, { data: { agregarContratoRelacionado } }) => {
            const query = {
              query: CONTRATO_RELACIONADOS,
              variables: {
                idContrato: this.contrato.id,
              },
            };
            const { contratoRelacionados } = store.readQuery(query);
            const contratoRelacionadosCopia = contratoRelacionados.slice();
            contratoRelacionadosCopia.push(agregarContratoRelacionado);
            store.writeQuery({
              ...query,
              data: {
                contratoRelacionados: contratoRelacionadosCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    // Eliminar Contrato Relacionado
    async mixEliminarContratoRelacionado() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_RELACIONADO,
        variables: {
          id: this.contratoRelacionadoEliminar.id,
        },
        // Remover Contrato Relacionado de la Store
        update: (store) => {
          const query = {
            query: CONTRATO_RELACIONADOS,
            variables: {
              idContrato: this.contratoRelacionadoEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoRelacionados } = data;
          const index = contratoRelacionados
            .findIndex((fianza) => fianza.id === this.contratoRelacionadoEliminar.id);
          if (index !== -1) {
            contratoRelacionados.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },

};
